module.exports = __webpack_public_path__ + "static/img/35.facfd7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/35.png
// module id = OC1W
// module chunks = 1